// extracted by mini-css-extract-plugin
module.exports = {"section":"SectionTabs_section__QS_Q_","sectionTab":"SectionTabs_sectionTab__IM_KK"};